import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_radio",
  "use": "svg_radio-usage",
  "viewBox": "0 0 16 13",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 13\" id=\"svg_radio\"><path d=\"M5.926 12.148.741 6.963l1.852-1.852 3.333 3.26L13.408.814l1.851 1.852-9.333 9.481Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol